export default "__VITE_ASSET__7bf20769__"